import React from 'react';
import { FormattedMessage } from 'react-intl';
import { DealProps, ModalType } from 'states/initialState';
import { Button, Stack } from 'react-bootstrap';
import { MoneyFormat } from 'components/Common/TextFormat'

interface ViewDealProps {
  deal: DealProps;
  setModalType: any;
  dealChanged: boolean;
  handleShow: any;
}

const ViewDeal = ({
  deal,
  setModalType,
  handleShow,
  dealChanged
}: ViewDealProps) => {

  const handleClick = () => {
    setModalType(ModalType.TL);
    handleShow();
  };

  return (
    <>
      <Stack gap={3} className="mx-4 pt-2 pb-4">
        <Stack gap={2} className="fs-5 p-3 bg-white">
          <Stack direction="horizontal">
            <FormattedMessage id="selectedDeal.loanAmt" />
            <MoneyFormat value={deal.loanAmount} cents={false} className="ms-auto"/>
          </Stack>
          <Stack direction="horizontal">
            <FormattedMessage id="selectedDeal.origFee" />
            <MoneyFormat value={deal.originationFee} className="ms-auto"/>
          </Stack>
          <Stack direction="horizontal">
            <FormattedMessage id="selectedDeal.disbursementAmt" />
            <MoneyFormat value={deal.disbursementAmount} className="ms-auto"/>
          </Stack>
          <Stack direction="horizontal">
            <FormattedMessage id="selectedDeal.payback" />
            <MoneyFormat value={deal.totalAmountPaidBack} className="ms-auto"/>
          </Stack>
        </Stack>
      </Stack>
      <div className="w-100 px-4" style={{ alignSelf: 'flex-end' }}>
        <Stack className="px-3 pb-4" direction="horizontal">
          <FormattedMessage id="selectedDeal.commission" />:
          <MoneyFormat value={deal.commission} className="ms-auto"/>
        </Stack>
        <Button
          disabled={dealChanged}
          className="w-100"
          onClick={handleClick}
          data-testid="viewDealCheckout"
        >
          <FormattedMessage id="selectedDeal.checkout" />
        </Button>
      </div>
    </>
  );
};

export default ViewDeal;
